import { onMount, useSmoothScroll } from "zyra";
import type { SiteState } from "./site-state";
export function useSiteBehavior(site: SiteState) {
  const { menu, searching } = site;
  useSmoothScroll({ duration: 0.85 });
  onMount(() => {
    const key = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        searching.value = !searching.value;
      }
      if (event.key === "Escape") {
        searching.value = false;
        menu.value = false;
      }
    };
    window.addEventListener("keydown", key);
    return () => {
      window.removeEventListener("keydown", key);
    };
  });
}
